var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageFiles',{attrs:{"files":_vm.files}})
}
var staticRenderFns = []

export { render, staticRenderFns }